"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const translations = {
    en: {
        'id-to-text': {
            'askem-help-improve': 'Help us improve',
        },
        'id-to-alt-text': {
            'askem-indeed-logo': 'Indeed survey',
            'askem-close-popup': 'Exit survey',
        },
    },
    en_US: {
        'id-to-text': {
            'askem-help-improve': 'Help us improve',
        },
        'id-to-alt-text': {
            'askem-indeed-logo': 'Indeed survey',
            'askem-close-popup': 'Exit survey',
        },
    },
    en_CA: {
        'id-to-text': {
            'askem-help-improve': 'Help us improve',
        },
        'id-to-alt-text': {
            'askem-indeed-logo': 'Indeed survey',
            'askem-close-popup': 'Exit survey',
        },
    },
    en_GB: {
        'id-to-text': {
            'askem-help-improve': 'Help us improve',
        },
        'id-to-alt-text': {
            'askem-indeed-logo': 'Indeed survey',
            'askem-close-popup': 'Exit survey',
        },
    },
    fr: {
        'id-to-text': {
            'askem-help-improve': 'Aidez-nous à nous améliorer',
        },
        'id-to-alt-text': {
            'askem-indeed-logo': 'Enquête Indeed',
            'askem-close-popup': 'Fermer',
        },
    },
    fr_FR: {
        'id-to-text': {
            'askem-help-improve': 'Aidez-nous à nous améliorer',
        },
        'id-to-alt-text': {
            'askem-indeed-logo': 'Enquête Indeed',
            'askem-close-popup': 'Fermer',
        },
    },
    fr_CA: {
        'id-to-text': {
            'askem-help-improve': 'Aidez-nous à nous améliorer',
        },
        'id-to-alt-text': {
            'askem-indeed-logo': 'Enquête Indeed',
            'askem-close-popup': 'Fermer',
        },
    },
    ja: {
        'id-to-text': {
            'askem-help-improve': 'サービス向上にご協力ください',
        },
        'id-to-alt-text': {
            'askem-indeed-logo': 'Indeed アンケート',
            'askem-close-popup': 'アンケートを終了',
        },
    },
    ja_JP: {
        'id-to-text': {
            'askem-help-improve': 'サービス向上にご協力ください',
        },
        'id-to-alt-text': {
            'askem-indeed-logo': 'Indeed アンケート',
            'askem-close-popup': 'アンケートを終了',
        },
    },
    nl: {
        'id-to-text': {
            'askem-help-improve': 'Help ons verbeteren',
        },
        'id-to-alt-text': {
            'askem-indeed-logo': 'Enquête van Indeed',
            'askem-close-popup': 'Enquête afsluiten',
        },
    },
    nl_NL: {
        'id-to-text': {
            'askem-help-improve': 'Help ons verbeteren',
        },
        'id-to-alt-text': {
            'askem-indeed-logo': 'Enquête van Indeed',
            'askem-close-popup': 'Enquête afsluiten',
        },
    },
    de: {
        'id-to-text': {
            'askem-help-improve': 'Ihr Feedback hilft uns',
        },
        'id-to-alt-text': {
            'askem-indeed-logo': 'Indeed-Umfrage',
            'askem-close-popup': 'Umfrage schließen',
        },
    },
    de_DE: {
        'id-to-text': {
            'askem-help-improve': 'Ihr Feedback hilft uns',
        },
        'id-to-alt-text': {
            'askem-indeed-logo': 'Indeed-Umfrage',
            'askem-close-popup': 'Umfrage schließen',
        },
    },
    en_IN: {
        'id-to-text': {
            'askem-help-improve': 'Help us improve',
        },
        'id-to-alt-text': {
            'askem-indeed-logo': 'Indeed survey',
            'askem-close-popup': 'Exit survey',
        },
    },
};
exports.default = translations;
//# sourceMappingURL=data:application/json;base64,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